module.exports = __webpack_public_path__ + "static/media/9295812d-b9c9-421e-82cc-50cb0bc74fba.41ef676d.jpeg";